import React, {Component} from 'react';
import {Form} from 'react-final-form';
import PropTypes from 'prop-types';
import {Link, Panel, FileUploader, SaveButton, Button, Tabs} from '../../common';
import UserAccount from './UserAccount';
import UserAdvanced from './UserAdvanced';
import UserTreasures from './UserTreasures';
import {goHistoryBack} from '../../../utils';

const PREFIX = 'f_';

export default class UserProfile extends Component {
  static propTypes = {
    onSaveUser: PropTypes.func.isRequired,
    fetchUserTreasures: PropTypes.func.isRequired,
    fetchUserDefinitions: PropTypes.func.isRequired,
    saveUserDefinitions: PropTypes.func.isRequired,
    userDefinitions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    treasures: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    user: PropTypes.shape({
      id: PropTypes.string,
      firstName: PropTypes.string,
      lastName: PropTypes.string,
      image: PropTypes.string,
      coins: PropTypes.shape({
        gold: PropTypes.number.isRequired,
      }).isRequired,
    }).isRequired,
    availablePoints: PropTypes.number.isRequired,
  };

  constructor(props) {
    const {user} = props;
    super(props);
    this.state = {
      user,
      editMode: false,
      selectedTab: 0,
    };
  }

  componentDidMount() {
    this.props.fetchUserDefinitions();
  }

  onFormSubmit = (data) => {
    const {user: {image = null}, selectedTab} = this.state;
    const {onSaveUser, saveUserDefinitions, userDefinitions} = this.props;
    const {firstName, lastName} = data;
    const definitionsToSave = [];

    switch (selectedTab) {
      case 0:
        this.setState(
          {editMode: false},
          onSaveUser({firstName, lastName, image})
        );
        break;
      case 2:
        userDefinitions.forEach((item) => {
          definitionsToSave.push({field: item.field, value: data[`${PREFIX}${item.field}`]});
        });
        this.setState({editMode: false});
        saveUserDefinitions({data: definitionsToSave});
        break;
      default:
        break;
    }
  };

  onFileUploaded = (image) => {
    const user = {...this.state.user, image};

    this.setState({user});
  };

  onAvatarRemove = () => {
    this.onFileUploaded(null);
  };

  switchToEdit = () => {
    this.setState({editMode: true});
  };

  renderTabs = () => {
    const {
      fetchUserTreasures, treasures, user,
      fetchUserDefinitions, userDefinitions,
      user: {coins: {gold}},
    } = this.props;
    const {editMode} = this.state;
    const tabs = [
      {title: 'General', children: <UserAccount editMode={editMode} {...user}/>},
      {
        title: 'Treasure Items',
        children: <UserTreasures
          treasures={treasures}
          fetchUserTreasures={fetchUserTreasures}
          availablePoints={gold}
        />,
      },
      {
        title: 'Advanced',
        children: <UserAdvanced
          userDefinitions={userDefinitions}
          fetchUserDefinitions={fetchUserDefinitions}
          editMode={editMode}
        />,
      },
    ];

    return <Tabs tabs={tabs} onSelectTab={this.onSelectTab}/>;
  };

  onSelectTab = (tabIndex) => {
    this.setState({selectedTab: tabIndex});
  };

  render() {
    const {user: {image, firstName, lastName}, editMode} = this.state;
    const {userDefinitions} = this.props;
    const showImageMenu = image && editMode;
    const initialValues = userDefinitions.reduce(
      (acc, {field, value}) => ({...acc, [`${PREFIX}${field}`]: value}), {firstName, lastName}
    );

    return (
      <Panel
        title="Profile"
        size="xl"
        headerSize="m"
        cls="profile-page"
      >
        <Form
          onSubmit={this.onFormSubmit}
          validateOnBlur={false}
          initialValues={initialValues}
          render={({handleSubmit, submitting}) => (
            <form
              action="#"
              className="form user-profile"
              onSubmit={handleSubmit}
            >
              <div className="row">
                <div className="cell cell_auto user-profile__avatar-wrap">
                  <FileUploader
                    modificator="avatar"
                    hint={`${firstName} ${lastName}`}
                    selectedMedia={image}
                    onFileUploaded={this.onFileUploaded}
                    editMode={editMode}
                  />
                  {showImageMenu &&
                    <ul className="menu menu_delimiter user-profile__avatar-links row_center">
                      <li className="menu-item">
                        <Link onClick={this.onAvatarRemove} text="Delete"/>
                      </li>
                    </ul>
                  }
                </div>
                <div className="cell cell_auto">
                  <div className="delimeter delimeter_vertical"/>
                </div>

                <div className="cell">

                  {this.renderTabs()}

                  <div className="row row_right user-profile__actions">
                    <Button size="l" text="Back" handler={goHistoryBack}/>
                    {editMode ?
                      <SaveButton size="l" type="submit" text="Save" disabled={submitting}/> :
                      <Button size="l" text="Edit" handler={this.switchToEdit}/>
                    }
                  </div>
                </div>
              </div>
            </form>
          )}
        />
      </Panel>
    );
  }
}
